import { Component, Input } from '@angular/core';
import {Estacao} from '../../../models/estacao.model';

@Component({
  selector: 'app-estacao-card',
  templateUrl: './estacao-card.component.html',
  styleUrls: ['./estacao-card.component.scss'],
})
export class EstacaoCardComponent {

  @Input() estacao: Estacao;
  @Input() tamanho: string;

  getQualidadeClass(classificacao) {
    const classes = {
      ['Boa'] : 'boa',
      ['Moderada'] : 'moderada',
      ['Ruim'] : 'ruim',
      ['Muito ruim'] : 'muito-ruim',
      ['Péssimo'] : 'pessimo'
    };
    return classes[classificacao];
  }

  getNoClassificacao(estacao) {
    return estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.noClassificacao;
  }

  getDtUltimaAtualizacaoFormated(date) {
    const newDate = new Date(date.replace(/\s/g, 'T'));
    return `${newDate.toLocaleDateString('pt-BR')} ${newDate.toLocaleTimeString('pt-BR').substr(0, 5)}`;
  }

  getMedicao(estacao) {
    const num: number = Number(estacao?.indiceQualidadeArAtual?.medicao?.indiceQualidadeAr);
    return num;
  }
}
